const BET_AMOUNT_MULTIPLIER = 100;

// Tolérance pour les cotes
const ODDS_THRESHOLD = 0.01;

module.exports = {
  BET_AMOUNT_MULTIPLIER,
  ODDS_THRESHOLD,
};
